import React from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
const Isotope = typeof window !== `undefined` ? require("isotope-layout/js/isotope") : null


class SortGallery extends React.Component {
  static propTypes = {
    grid: PropTypes.string,
    gridItem: PropTypes.string,
    sortArray: PropTypes.object,
    layoutM: PropTypes.string,
    noItem: PropTypes.string,
    oneItem: PropTypes.string,
    classRow: PropTypes.string,
    classCol: PropTypes.string,
    colHrefName: PropTypes.string
  }

  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this,{filter:'*'});

  }

  handleClick(e,type,id,classId) {

    if (id !== undefined){
      if (id==="6") {
        this.scrollTo(document.getElementById(classId),true)
      }
      else{
        this.scrollTo(document.getElementById(classId));
      }
    }

    if (this.props.oneItem!== undefined) {
      $('button.'+id).trigger( 'click' );
      return 1;
    }
    if (id !== undefined) {
      $('.all').removeClass('active');
      $('.'+id).addClass('active');
    }

    if (this.iso===undefined)
      this.iso = new Isotope(`.${this.props.grid}`, {
        itemSelector: `.${this.props.gridItem}`,
        layoutMode: `${this.props.layoutM}`
      });
    this.iso.arrange(type);
  }

  scrollTo(element, style=0, offSet = 0, timeout = null) {
    const elemPos = element
      ? element.getBoundingClientRect().top + window.pageYOffset
      : 0;

      if (style===true) {
          offSet = -106;
        if ((window.innerWidth<1600)&&(window.innerWidth>1200)) {
            offSet = -92;
        }else if ((window.innerWidth<1200)&&(window.innerWidth>992)) {
            offSet = -83;
        }else if ((window.innerWidth<992)&&(window.innerWidth>768)) {
            offSet = -64;
        }
      } else {
        if(window.innerWidth<737) {
          offSet= - 75;
        }
        if (window.innerWidth>737) {
          offSet= - 136;
        }
      }

    if (timeout) {
      setTimeout(() => {
        window.scroll({ top: elemPos + offSet, left: 0, behavior: 'smooth' });
      }, timeout);
    } else {
      window.scroll({ top: elemPos + offSet, left: 0, behavior: 'smooth' });
    }
  }

  render() {
    return (
      <div className={this.props.classRow}>

      {
        this.props.oneItem===undefined?(
          this.props.sortArray.map((item,i)=>(
              <div className={this.props.classCol}>

                    <button className={(i===0?'active':'')+' '+i+' all'}
                      onClick={this.handleClick.bind(this,item[1],i,this.props.colHrefName)}
                    >
                      {item[0]}
                    </button>

              </div>
              ))
            ):(
              <div className={this.props.classCol}>
              <button className={this.props.oneItem+' all'}
                onClick={this.handleClick.bind(this,this.props.sortArray[this.props.noItem][1],this.props.oneItem,this.props.colHrefName)}
                >
              {this,this.props.sortArray[this.props.noItem][0]}
              </button>
            </div>
          )
        }


      </div>
    );
  }
}
SortGallery.defaultProps = {
  classRow: "row d-flex align-items-center justify-content-center my-3 sort-row",
  classCol: "col-md col-sm-12 my-md-2 d-flex justify-content-center my-1",
  colHrefName:"screen_gal"
}

export default SortGallery;
